import { useEffect, useState } from 'react';

const useHeaderHeight = () => {
  // setting initial value 80 default height
  const [height, setHeight] = useState(80);

  useEffect(() => {
    const headerContent = document.getElementById('header-content');

    if (!headerContent) {
      return;
    }

    const resizeObserver = new ResizeObserver(entries => {
      entries.forEach(entry => {
        if (entry.contentRect) {
          setHeight(entry.contentRect.height);
        }
      });
    });

    resizeObserver.observe(headerContent);

    // eslint-disable-next-line consistent-return
    return () => {
      resizeObserver.unobserve(headerContent);
      resizeObserver.disconnect();
    };
  }, []);

  return { height };
};

export default useHeaderHeight;
